import { createAction } from 'redux-act';

export const renewProgram = createAction();